import { Box, Container, Typography } from '@material-ui/core';
import React from 'react';

const UnavailablePage: React.FC = () => {
  return (
    <Container disableGutters maxWidth="xl">
      <Box mb={4}>
        <Typography variant="h2">Unavailable</Typography>
      </Box>
      <Box mb={3}>
        <Typography variant="body1">
          The page you are trying to access is unavailable.
        </Typography>
      </Box>
    </Container>
  );
};

export default UnavailablePage;
